function getQueryObject(str) {
	var questionMark = str.indexOf('?');
	var sharpMark = str.indexOf('#');

	if (questionMark === -1) return {};

	var qs = sharpMark > -1 ? str.slice(questionMark + 1, sharpMark) : str.slice(questionMark + 1);

  var qparams = {};
  var q = qs.split('&');

  for (var i = 0; i <  q.length; i++){
    var pair = q[i].split('=');
    qparams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	}
	return qparams;
}

module.exports = getQueryObject;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/qparams.js
// module id = 511
// module chunks = 0